import React, {useState} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';

import client from '../common/client';

export default function BlockCopyDialog(props) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCopy = () => {
    if(props.onComplete && props.block_id && value) {
        setLoading(true)
        client.request_post(`/api/rule/copy`, {
            src_block_id :value,
            dst_block_id :props.block_id
        }).then(res=>{
            setLoading(false)
            if(res && res.r) {
              props.onComplete()
              setOpen(false);
            } else if(res && !res.r) {
              alert('Fail to copy ' + (res.msg?res.msg:''))
            }
        })
    }
  };

  return (
    <div>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}> Copy Rule From</Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Copy Block Rule</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Copy all rules to this block
          </DialogContentText>
          <TextField
            autoFocus
            onChange={(e)=>{setValue(e.target.value)}}
            margin="dense"
            id="block_id"
            label="Block Id"
            type="email"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCopy} color="primary" startIcon={loading && <CircularProgress size={20}/>}>
            Copy Start
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}